export default class GetPackageInfoArgs {
    public categoryId = 0;
    public targetProducts: number[] = [];
    public storeId = 0;
    public isProductGroupMember: boolean | undefined = false;
}
